<div *ngIf="!showContent">
</div>
<div *ngIf="showContent" class="not-found-container">
  <div class="not-found">
    <h1>Data Not Found</h1>
    <p style="margin-bottom: 10px;">Sorry, the data you are looking for does not exist.</p>
    <a routerLink="/" class="back-link">Go back to Home</a>
  </div>
</div>
